import $ from "jquery";

export const partnersWidgetHeight = () => {
    const partnersWidgetWrapper = $('.partners-widget-wrapper');

    if (partnersWidgetWrapper.length === 0) {
        return;
    }

    const header = $('#wrapper__header');
    const partnersWidgetWrapperMargin = parseInt(partnersWidgetWrapper.css("margin-top"));
    const barHeight = document.documentElement.clientHeight - header.height() - partnersWidgetWrapperMargin / 2;

    partnersWidgetWrapper.css('height', barHeight);
}
